export class WoodType {
  ItemName: string;
  ItemGUID: string;
}
export enum WoodTypeEnum {
  PressureTreated = "Pressure Treated Lumber",
  Hardwood = "Hardwood",
  Cedar = "Cedar",
  Composite = "Composite Wood",
  Redwood = "Redwood",
  All = "All",
  WaterGuard = "Water Guard"
}



// WEBPACK FOOTER //
// ./src/app/models/wood-type.ts